const Badge = ({ x, y, s }) => (
  <g transform={`translate(${x} ${y})`}>
    <polygon points={`${s * 0.12},0 ${s},0 ${s * 0.88},${s} 0,${s}`} fill="#FF3B30" />
    <text x={s / 2} y={s * 0.68} textAnchor="middle" fontSize={s * 0.42} fontWeight="900" fontFamily="Arial Black, Arial, sans-serif" fill="#fff">ABS</text>
  </g>
);

const Tank = ({ color, placement }) => (
  <svg viewBox="0 0 200 240" className="w-full h-full">
    <path d="M55 20 Q65 60 100 60 Q135 60 145 20 L165 30 L158 100 L158 225 L42 225 L42 100 L35 30 Z" fill={color} stroke="#ffffff66" strokeWidth="2" />
    {placement === "back" && <text x="100" y="18" textAnchor="middle" fontSize="9" fill="#777" fontFamily="monospace">BACK VIEW</text>}
    {placement === "chest" && <Badge x={76} y={88} s={48} />}
    {placement === "back" && <Badge x={62} y={100} s={76} />}
  </svg>
);

const Cap = ({ color }) => (
  <svg viewBox="0 0 200 240" className="w-full h-full">
    <path d="M40 130 Q40 50 100 50 Q160 50 160 130 Z" fill={color} stroke="#ffffff66" strokeWidth="2" />
    <path d="M30 130 L170 130 L190 150 L10 150 Z" fill={color} stroke="#ffffff66" strokeWidth="2" />
    <line x1="100" y1="52" x2="100" y2="130" stroke="#00000033" />
    <Badge x={78} y={78} s={44} />
  </svg>
);

const Bottle = ({ color, placement }) => (
  <svg viewBox="0 0 200 240" className="w-full h-full">
    <rect x="80" y="10" width="40" height="22" rx="4" fill="#333" />
    <path d="M60 40 Q60 30 70 30 L130 30 Q140 30 140 40 L140 215 Q140 228 127 228 L73 228 Q60 228 60 215 Z" fill={color} stroke="#ffffff66" strokeWidth="2" />
    {placement === "front" && <Badge x={76} y={100} s={48} />}
    {placement === "wrap" && <Badge x={62} y={80} s={76} />}
  </svg>
);

const SHAPES = { tank: Tank, cap: Cap, bottle: Bottle };

export const PodPreview = ({ kind, color, placement }) => {
  const Shape = SHAPES[kind] || Tank;
  return (
    <div data-testid="customize-preview" className="relative aspect-[5/6] bg-neutral-800 border border-white/10 grid place-items-center p-6 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.07] bg-[radial-gradient(circle_at_30%_20%,#fff,transparent_60%)]" />
      <Shape color={color} placement={placement} />
      <p className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-widest text-neutral-500">Live preview · approximate</p>
    </div>
  );
};
